import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator } from '@angular/forms';

/** 10 dígitos = fixo, 11 dígitos = celular. */
export function phoneValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const v = control.value;
    if (v == null || v === '') return null;
    const digits = String(v).replace(/\D/g, '');
    if (digits.length < 10 || digits.length > 11) return { phone: true };
    return null;
  };
}

/** Diretiva para uso com ngModel em Template-driven Forms. */
@Directive({
  selector: '[appPhone]',
  standalone: true,
  providers: [{ provide: NG_VALIDATORS, useExisting: PhoneValidatorDirective, multi: true }],
})
export class PhoneValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return phoneValidator()(control);
  }
}
